import { GeneratedQuery } from "../graphql";
import * as APITypes from "../API";
/* tslint:disable */
/* eslint-disable */

export const getBlockInteractionPaging = /* GraphQL */ `
  query GetBlockInteractionPaging(
    $zoneId: ID!
    $blockId: ID!
    $nextToken: String
    $limit: Int
  ) {
    getBlock(zoneId: $zoneId, blockId: $blockId) {
      zoneId
      blockId
      blockType
      index
      accessLevel
      writeAccessLevel
      groups
      options
      data
      interactions(nextToken: $nextToken, limit: $limit) {
        items {
          blockId
          interactionKey
          data
          participantId
          timestamp
          expires
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
` as GeneratedQuery<
  APITypes.GetBlockInteractionPagingQueryVariables,
  APITypes.GetBlockInteractionPagingQuery
>;
